// extracted by mini-css-extract-plugin
module.exports = {"header":"SalesregHeader_header__2iZhi","syncBtn":"SalesregHeader_syncBtn__2_26v","rightSection":"SalesregHeader_rightSection__18s4B"};